import React from "react";

import UserQuestionnaireDtls from "./UserQuestionnaireDtls";

const Questionnaire = () => {

    return (
        <div>
            {/* <div className="d-flex justify-content-between mt-3 mb-3">
                <h2 className="page-heading">Questionnaire</h2>

                <Link to="/q1" className="as-btn-primary profile-light-btn">
                    Re-take Questionnaire
                </Link>
            </div> */}
            <div className="page-header">
                <h2>Questionnaire</h2>
                <p>Every form, every response, right where you need it.</p>
            </div>
            <UserQuestionnaireDtls />
        </div>
    );
};

export default Questionnaire;
